module.exports = __webpack_public_path__ + "static/media/Filter.1de93efa.svg";